module.exports = __webpack_public_path__ + "img/shoucang.2b48e00c.svg";